<div class="personal-service-setting-container" testId="personal-service-setting-page">
  <nz-spin [nzSpinning]="loading" [nzTip]="'common.loading' | i18n" testId="personal-service-setting-spin">
    <div class="content-wrapper" testId="personal-service-setting-content">
      <servicenumber-config
        [serviceNumberId]="serviceNumberId"
        [serviceNumberType]="serviceNumberType"
        [tenantType]="tenantType"
        (unsavedChangesChange)="onUnsavedChangesChange($event)"
        testId="personal-service-setting-config"
      />
    </div>
  </nz-spin>
</div>
